import React, { Component } from "react";

import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getTikTokAdvertisersList, integrationStateInit } from "../../../store/integration/actions";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class TikTokAdvertisers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getTikTokAdvertisersList({ ...this.props.data, search: null });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
  }

  componentWillUnmount() {
    this.props.integrationStateInit()
  }

  handleTableChange = (data) => {
      this.props.getTikTokAdvertisersList(data);
  };

  render() {
    const columns = [
      {
        dataField: "advertiser_id",
        text: "Advertiser id",
        sort: true,
      },
      {
        dataField: "advertiser_name",
        text: "Advertiser name",
        sort: true
      }
    ];

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Advertisers TikTok | Mobihunter" />

          <Container fluid>
            <Breadcrumbs title="Dashboard" breadcrumbItem="Advertisers TikTok" link="/dashboard"/>
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

TikTokAdvertisers.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  getTikTokAdvertisersList: PropTypes.func.isRequired,
  integrationStateInit: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  data: state.Integration.dataAdvertisersTikTok,
  loading: state.Integration.loading_advertisers_tiktok,
  permissions: state.User.permissions
});

export default connect(mapStateToProps, { getTikTokAdvertisersList, integrationStateInit })(
  TikTokAdvertisers
);